var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Recomendações: ")]),(_vm.recommendations)?_c('span',{staticClass:"black--text"},[_vm._v(" "+_vm._s(_vm.recommendations)+" ")]):_c('span',{staticClass:"grey--text"},[_vm._v(" Nenhuma recomendação para esse par. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }